export type CabinaTab = 'chat' | 'saludos' | 'canciones' | 'encuestas' | 'concursos' | 'top-fans';

export type ModeracionAction = 'responder' | 'destacar' | 'eliminar' | 'bloquear' | 'banear' | 'mover-al-aire';

export type CabinaMessageType = 'mensaje' | 'saludo' | 'cancion' | 'voz' | 'concurso_respuesta' | 'encuesta_voto';

export interface CabinaMessage {
  id: number;
  senderName: string;
  senderAvatar: string;
  senderBadge?: string;
  type: CabinaMessageType;
  content: string;
  songRequest?: string;
  voiceDuration?: string;
  contestAnswer?: string;
  pollVote?: string;
  destacado: boolean;
  bloqueado: boolean;
  timestamp: string;
  esVIP: boolean;
  esEmbajador: boolean;
}

export interface CabinaEncuesta {
  id: number;
  pregunta: string;
  opciones: { id: number; texto: string; votos: number }[];
  totalVotos: number;
  activa: boolean;
  tiempoRestante: string;
  creadaPor: string;
}

export interface CabinaConcurso {
  id: number;
  titulo: string;
  premio: string;
  pregunta: string;
  respuestas: { usuario: string; respuesta: string; timestamp: string }[];
  ganador?: string;
  activo: boolean;
  tiempoRestante: string;
}

export interface CabinaTopFan {
  id: number;
  nombre: string;
  avatar: string;
  nivel: string;
  mensajes: number;
  racha: number;
  insignia: string;
}

export interface CabinaLocutorInfo {
  nombre: string;
  avatar: string;
  bio: string;
  estado: string;
  programa: string;
  cobertura: string;
  seguidores: number;
}

export interface CabinaStats {
  oyentesAhora: number;
  oyentesPico: number;
  mensajesHoy: number;
  saludosHoy: number;
  cancionesHoy: number;
  encuestasActivas: number;
  concursosActivos: number;
  vipsEnCabina: number;
  embajadoresEnCabina: number;
  topFansActivos: number;
  mensajesPorMinuto: number;
}

export const tabsConfig: { id: CabinaTab; label: string; icono: string; descripcion: string }[] = [
  { id: 'chat', label: 'Chat', icono: 'ri-chat-3-line', descripcion: 'Todos los mensajes en tiempo real' },
  { id: 'saludos', label: 'Saludos', icono: 'ri-user-heart-line', descripcion: 'Saludos al aire de los oyentes' },
  { id: 'canciones', label: 'Canciones', icono: 'ri-music-line', descripcion: 'Pedidos y dedicatorias musicales' },
  { id: 'encuestas', label: 'Encuestas', icono: 'ri-bar-chart-line', descripcion: 'Votaciones en vivo' },
  { id: 'concursos', label: 'Concursos', icono: 'ri-trophy-line', descripcion: 'Participá y ganá premios' },
  { id: 'top-fans', label: 'Top Fans', icono: 'ri-star-line', descripcion: 'Los más activos de la comunidad' },
];

export const moderacionConfig: { id: ModeracionAction; label: string; icono: string; color: string; shortcut: string; descripcion: string }[] = [
  { id: 'responder', label: 'Responder', icono: 'ri-reply-line', color: 'from-emerald-400 to-emerald-600', shortcut: 'R', descripcion: 'Responder al mensaje seleccionado' },
  { id: 'destacar', label: 'Destacar', icono: 'ri-star-line', color: 'from-amber-400 to-amber-600', shortcut: 'D', descripcion: 'Destacar mensaje en el aire' },
  { id: 'eliminar', label: 'Eliminar', icono: 'ri-delete-bin-line', color: 'from-rose-400 to-rose-600', shortcut: 'E', descripcion: 'Eliminar mensaje del chat' },
  { id: 'bloquear', label: 'Bloquear', icono: 'ri-shield-line', color: 'from-orange-400 to-orange-600', shortcut: 'B', descripcion: 'Bloquear usuario temporalmente' },
  { id: 'banear', label: 'Banear', icono: 'ri-forbid-2-line', color: 'from-red-400 to-red-700', shortcut: 'X', descripcion: 'Banear usuario permanentemente' },
  { id: 'mover-al-aire', label: 'Mover al Aire', icono: 'ri-broadcast-line', color: 'from-violet-400 to-violet-600', shortcut: 'M', descripcion: 'Mover mensaje al aire en vivo' },
];

export const locutorActual: CabinaLocutorInfo = {
  nombre: 'Valentina Ríos',
  avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20radio%20host%20woman%20with%20confident%20charismatic%20smile%2C%20professional%20studio%20lighting%2C%20warm%20expression%2C%20stylish%20casual%20look%2C%20headshot%20photography%2C%20clean%20dark%20background%2C%20editorial%20quality&width=160&height=160&seq=cabina2-locutor-valentina&orientation=squarish',
  bio: 'Locutora estrella de Estéreo Capital. 8 años al aire.',
  estado: 'EN VIVO',
  programa: 'Tardes con Vale',
  cobertura: 'México & Latinoamérica',
  seguidores: 48500,
};

export const programaActual = {
  nombre: 'Tardes con Vale',
  horario: '15:00 - 18:00 CST',
  tiempoRestante: '1h 42min',
  progreso: 43,
  categoria: 'Entretenimiento',
  radio: 'Estéreo Capital 102.1 FM',
  oyentes: 5124,
};

export const cabinaMensajes: CabinaMessage[] = [
  {
    id: 1,
    senderName: 'María Fernanda López',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20friendly%20approachable%20expression%2C%20clean%20light%20background%2C%20casual%20style&width=80&height=80&seq=cabina2-avatar-maria&orientation=squarish',
    type: 'cancion',
    content: 'Buenas tardes! Me encantaría escuchar "Vivir Mi Vida" de Marc Anthony, es mi canción favorita y hoy estoy celebrando mi cumpleaños. Sería el mejor regalo!',
    songRequest: 'Vivir Mi Vida — Marc Anthony',
    destacado: true,
    bloqueado: false,
    timestamp: '2026-06-21T16:12:00',
    esVIP: false,
    esEmbajador: false,
    senderBadge: undefined,
  },
  {
    id: 2,
    senderName: 'Carlos Ramírez',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20friendly%20face%2C%20casual%20polo%20shirt%2C%20natural%20daylight%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-carlos&orientation=squarish',
    senderBadge: 'VIP Oro',
    type: 'saludo',
    content: 'Un saludo enorme para toda la gente de San José que nos escucha desde temprano. ¡Arriba el barrio El Carmen! Y un abrazo para mi esposa Andrea, todo va a salir bien.',
    destacado: true,
    bloqueado: false,
    timestamp: '2026-06-21T16:08:00',
    esVIP: true,
    esEmbajador: false,
  },
  {
    id: 3,
    senderName: 'Andrea Torres',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20bright%20smile%2C%20everyday%20casual%20look%2C%20soft%20daylight%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20light%20background&width=80&height=80&seq=cabina2-avatar-andrea&orientation=squarish',
    type: 'concurso_respuesta',
    content: 'Para el concurso de las entradas del Summer Fest: la respuesta es "Los Ecos" — la banda que abrió el festival del año pasado.',
    contestAnswer: 'Los Ecos',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T16:05:00',
    esVIP: false,
    esEmbajador: false,
    senderBadge: undefined,
  },
  {
    id: 4,
    senderName: 'Diego Montenegro',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%20with%20beard%2C%20stylish%20casual%20look%2C%20confident%20friendly%20expression%2C%20modern%20studio%20lighting%2C%20clean%20warm%20background&width=80&height=80&seq=cabina2-avatar-diego&orientation=squarish',
    senderBadge: 'Embajador Platino',
    type: 'mensaje',
    content: 'Amé la entrevista que hicieron a Los Ecos el jueves. Pregúntenles en la próxima si van a sacar nuevo álbum este año, necesito más música de ellos.',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T16:01:00',
    esVIP: true,
    esEmbajador: true,
  },
  {
    id: 5,
    senderName: 'Lucía Mendoza',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20with%20warm%20genuine%20smile%2C%20natural%20makeup%2C%20casual%20look%2C%20soft%20natural%20light%2C%20clean%20bright%20background&width=80&height=80&seq=cabina2-avatar-lucia&orientation=squarish',
    type: 'voz',
    content: 'Mensaje de voz — 0:42',
    voiceDuration: '0:42',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T15:58:00',
    esVIP: false,
    esEmbajador: false,
    senderBadge: undefined,
  },
  {
    id: 6,
    senderName: 'Pedro Gutiérrez',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%20with%20kind%20eyes%2C%20simple%20casual%20style%2C%20natural%20lighting%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-pedro&orientation=squarish',
    type: 'cancion',
    content: 'Para dedicar a mi esposa en nuestro aniversario 25: "Perfect" de Ed Sheeran. Gracias por acompañarnos todos estos años.',
    songRequest: 'Perfect — Ed Sheeran',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T15:50:00',
    esVIP: false,
    esEmbajador: false,
    senderBadge: undefined,
  },
  {
    id: 7,
    senderName: 'Sofía Hernández',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20trendy%20casual%20style%2C%20bright%20genuine%20smile%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-sofia&orientation=squarish',
    senderBadge: 'Top Fan Diamante',
    type: 'saludo',
    content: 'Buenas! Saludos para todo el equipo, son los mejores. Especialmente para Vale que nos alegra las tardes y a Diego que siempre me hace reír.',
    destacado: true,
    bloqueado: false,
    timestamp: '2026-06-21T15:45:00',
    esVIP: true,
    esEmbajador: false,
  },
  {
    id: 8,
    senderName: 'Roberto Sánchez',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20casual%20style%2C%20friendly%20expression%2C%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-roberto&orientation=squarish',
    type: 'concurso_respuesta',
    content: 'Concurso de entradas Summer Fest — respuesta: Fueron 12 bandas en total las que tocaron en el Parque Central.',
    contestAnswer: '12 bandas',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T15:40:00',
    esVIP: false,
    esEmbajador: false,
    senderBadge: undefined,
  },
  {
    id: 9,
    senderName: 'Valentina Castro',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20artistic%20style%2C%20creative%20look%2C%20warm%20smile%2C%20soft%20ambient%20light%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-valentina&orientation=squarish',
    senderBadge: 'Embajador Platino',
    type: 'mensaje',
    content: 'Propongo que hagan un segmento de covers acústicos en vivo los viernes. Los oyentes podemos votar la canción y el locutor la canta. "Viernes de Acústico".',
    destacado: true,
    bloqueado: false,
    timestamp: '2026-06-21T15:35:00',
    esVIP: true,
    esEmbajador: true,
  },
  {
    id: 10,
    senderName: 'SpamBot_2024',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Generic%20default%20avatar%20placeholder%2C%20plain%20simple%20icon%20style%2C%20neutral%20expression%2C%20clean%20minimal%20background%2C%20anonymous%20user%20icon&width=80&height=80&seq=cabina2-avatar-spam&orientation=squarish',
    type: 'mensaje',
    content: '¡¡¡OFERTA LIMITADA!!! Compra ahora nuestro producto milagroso. 50% descuento. Visita bit.ly/falso. ¡No te lo pierdas!',
    destacado: false,
    bloqueado: true,
    timestamp: '2026-06-21T15:30:00',
    esVIP: false,
    esEmbajador: false,
    senderBadge: undefined,
  },
  {
    id: 11,
    senderName: 'Ana Patricia Vega',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20mature%20Latina%20woman%2C%20elegant%20casual%20style%2C%20warm%20genuine%20smile%2C%20soft%20natural%20light%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-ana&orientation=squarish',
    type: 'cancion',
    content: 'Para la hora del café, ¿podrían poner "Ojalá" de Silvio Rodríguez? Es una canción que me conecta con mis raíces y siempre me hace reflexionar.',
    songRequest: 'Ojalá — Silvio Rodríguez',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T15:20:00',
    esVIP: false,
    esEmbajador: false,
    senderBadge: undefined,
  },
  {
    id: 12,
    senderName: 'Octavio Mendoza',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20distinguished%20older%20Latino%20gentleman%2C%20silver%20hair%2C%20kind%20wise%20eyes%2C%20elegant%20casual%2C%20warm%20natural%20light%2C%20clean%20soft%20background&width=80&height=80&seq=cabina2-avatar-octavio&orientation=squarish',
    senderBadge: 'VIP Oro',
    type: 'saludo',
    content: 'Desde Heredia para todos los radioescuchas de la 102.1 FM. Sintonizándolos desde hace 15 años, el mejor acompañamiento. ¡Pura vida!',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T15:15:00',
    esVIP: true,
    esEmbajador: false,
  },
  {
    id: 13,
    senderName: 'Natalia Campos',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20in%20her%2030s%2C%20warm%20friendly%20smile%2C%20casual%20chic%20style%2C%20soft%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-natalia&orientation=squarish',
    type: 'voz',
    content: 'Mensaje de voz — 0:28',
    voiceDuration: '0:28',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T15:10:00',
    esVIP: false,
    esEmbajador: false,
    senderBadge: undefined,
  },
  {
    id: 14,
    senderName: 'Javier Núñez',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20trendy%20street%20style%2C%20charismatic%20smile%2C%20urban%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-javier&orientation=squarish',
    type: 'concurso_respuesta',
    content: 'Concurso Summer Fest — la respuesta es: 3 días duró el festival: viernes, sábado y domingo con más de 15,000 asistentes.',
    contestAnswer: '3 días',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T15:05:00',
    esVIP: false,
    esEmbajador: false,
    senderBadge: undefined,
  },
  {
    id: 15,
    senderName: 'Daniela Quirós',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20fit%20Latina%20woman%2C%20sporty%20casual%20look%2C%20energetic%20smile%2C%20bright%20natural%20light%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-daniela&orientation=squarish',
    senderBadge: 'Top Fan Diamante',
    type: 'mensaje',
    content: 'Vale, sos la mejor locutora! Me acompañás todas las tardes en el gym y haces mi rutina mucho más divertida. ¡Gracias por existir!',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T15:00:00',
    esVIP: true,
    esEmbajador: false,
  },
  {
    id: 16,
    senderName: 'Mario Castillo',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%2C%20distinguished%20look%2C%20kind%20eyes%2C%20simple%20elegant%20style%2C%20classic%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-mario&orientation=squarish',
    type: 'cancion',
    content: 'Para recordar viejos tiempos: "Hotel California" de Eagles. Esta canción marcó mi juventud. Gracias por mantener viva la buena música.',
    songRequest: 'Hotel California — Eagles',
    destacado: true,
    bloqueado: false,
    timestamp: '2026-06-21T14:55:00',
    esVIP: false,
    esEmbajador: false,
    senderBadge: undefined,
  },
  {
    id: 17,
    senderName: 'Jimena Rivas',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20fresh%20natural%20look%2C%20warm%20smile%2C%20bright%20morning%20light%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-jimena&orientation=squarish',
    type: 'encuesta_voto',
    content: 'Voté en la encuesta: ¿Mejor canción del verano? — Mi voto: "Bzrp Music Sessions Vol. 53"',
    pollVote: 'Bzrp Music Sessions Vol. 53',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T14:50:00',
    esVIP: false,
    esEmbajador: false,
    senderBadge: undefined,
  },
  {
    id: 18,
    senderName: 'Oscar Duarte',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20mature%20Latino%20man%2C%20rugged%20friendly%20face%2C%20casual%20workwear%20style%2C%20natural%20outdoor%20lighting%2C%20clean%20warm%20background&width=80&height=80&seq=cabina2-avatar-oscar&orientation=squarish',
    senderBadge: 'VIP Oro',
    type: 'saludo',
    content: 'Petición especial: mi hija está en el hospital y hoy es su cumpleaños. ¿Podrían dedicarle una canción de Taylor Swift? Sería un momento muy especial.',
    destacado: true,
    bloqueado: false,
    timestamp: '2026-06-21T14:45:00',
    esVIP: true,
    esEmbajador: false,
  },
  {
    id: 19,
    senderName: 'Adrián Chaves',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20casual%20urban%20style%2C%20relaxed%20smile%2C%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-adrian&orientation=squarish',
    type: 'cancion',
    content: 'Simple: ¿me complacen con "Bohemian Rhapsody" de Queen? Es un temazo y hace rato no lo ponen. Sería épico escucharlo.',
    songRequest: 'Bohemian Rhapsody — Queen',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T14:40:00',
    esVIP: false,
    esEmbajador: false,
    senderBadge: undefined,
  },
  {
    id: 20,
    senderName: 'Camila Soto',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20modern%20trendy%20style%2C%20bright%20genuine%20smile%2C%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=cabina2-avatar-camila&orientation=squarish',
    senderBadge: 'Embajador Platino',
    type: 'mensaje',
    content: 'Chicos, organicen un meetup de oyentes en CDMX. Somos una comunidad enorme y sería increíble conocernos en persona. Yo ayudo a organizar.',
    destacado: false,
    bloqueado: false,
    timestamp: '2026-06-21T14:35:00',
    esVIP: true,
    esEmbajador: true,
  },
];

export const cabinaEncuestas: CabinaEncuesta[] = [
  {
    id: 1,
    pregunta: '¿Mejor canción del verano 2026?',
    opciones: [
      { id: 1, texto: 'Bzrp Music Sessions Vol. 53', votos: 2847 },
      { id: 2, texto: 'Flowers — Miley Cyrus', votos: 2193 },
      { id: 3, texto: 'La Bebé — Yng Lvcas', votos: 1654 },
      { id: 4, texto: 'Un Finde — Ke Personajes', votos: 3120 },
    ],
    totalVotos: 9814,
    activa: true,
    tiempoRestante: '18min',
    creadaPor: 'Valentina Ríos',
  },
  {
    id: 2,
    pregunta: '¿Próximo invitado a la cabina?',
    opciones: [
      { id: 1, texto: 'DJ Phantom — Set en vivo', votos: 4210 },
      { id: 2, texto: 'Los Ecos — Acústico', votos: 3654 },
      { id: 3, texto: 'María Becerra — Entrevista', votos: 2891 },
    ],
    totalVotos: 10755,
    activa: true,
    tiempoRestante: '42min',
    creadaPor: 'Diego Quintero',
  },
  {
    id: 3,
    pregunta: '¿Nuevo segmento para las mañanas?',
    opciones: [
      { id: 1, texto: 'Noticias + Café (15 min)', votos: 3245 },
      { id: 2, texto: 'Trivia Matutina (10 min)', votos: 4120 },
      { id: 3, texto: 'Música sin pausa (20 min)', votos: 1897 },
      { id: 4, texto: 'Entrevistas Express (15 min)', votos: 2533 },
    ],
    totalVotos: 11795,
    activa: false,
    tiempoRestante: 'Finalizada',
    creadaPor: 'Valentina Ríos',
  },
];

export const cabinaConcursos: CabinaConcurso[] = [
  {
    id: 1,
    titulo: 'Entradas VIP Summer Fest 2026',
    premio: '2 entradas VIP + backstage pass',
    pregunta: '¿Qué banda abrió el Summer Fest del año pasado?',
    respuestas: [
      { usuario: 'Andrea Torres', respuesta: 'Los Ecos', timestamp: '2026-06-21T16:05:00' },
      { usuario: 'Roberto Sánchez', respuesta: '12 bandas', timestamp: '2026-06-21T15:40:00' },
      { usuario: 'Javier Núñez', respuesta: '3 días', timestamp: '2026-06-21T15:05:00' },
      { usuario: 'Daniela Quirós', respuesta: 'DJ Phantom', timestamp: '2026-06-21T14:30:00' },
      { usuario: 'Ricardo Alfaro', respuesta: 'Los Ecos', timestamp: '2026-06-21T14:15:00' },
    ],
    activo: true,
    tiempoRestante: '22min',
  },
  {
    id: 2,
    titulo: 'Meet & Greet con Valentina Ríos',
    premio: 'Cena con Vale + foto autografiada',
    pregunta: '¿Cuál fue el primer programa de Vale en Estéreo Capital?',
    respuestas: [
      { usuario: 'Sofía Hernández', respuesta: 'Amanecer Musical', timestamp: '2026-06-21T15:30:00' },
      { usuario: 'Pedro Gutiérrez', respuesta: 'Tardes con Vale', timestamp: '2026-06-21T15:15:00' },
      { usuario: 'Ana Patricia Vega', respuesta: 'Amanecer Musical', timestamp: '2026-06-21T14:50:00' },
    ],
    activo: true,
    tiempoRestante: '1h 15min',
  },
  {
    id: 3,
    titulo: 'Kit de Merch Oficial RFW',
    premio: 'Remera, gorra, taza y stickers RFW',
    pregunta: '¿En qué año se fundó RadioFrecuenciaWeb?',
    respuestas: [
      { usuario: 'María Fernanda López', respuesta: '2018', timestamp: '2026-06-21T14:20:00' },
      { usuario: 'Carlos Ramírez', respuesta: '2019', timestamp: '2026-06-21T14:10:00' },
      { usuario: 'Octavio Mendoza', respuesta: '2018', timestamp: '2026-06-21T13:55:00' },
      { usuario: 'Natalia Campos', respuesta: '2020', timestamp: '2026-06-21T13:40:00' },
      { usuario: 'Mario Castillo', respuesta: '2018', timestamp: '2026-06-21T13:25:00' },
      { usuario: 'Adrián Chaves', respuesta: '2018', timestamp: '2026-06-21T13:10:00' },
    ],
    ganador: 'María Fernanda López',
    activo: false,
    tiempoRestante: 'Finalizado',
  },
];

export const cabinaTopFans: CabinaTopFan[] = [
  { id: 1, nombre: 'Sofía Hernández', avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20trendy%20casual%20style%2C%20bright%20genuine%20smile%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=cabina2-topfan-sofia&orientation=squarish', nivel: 'Diamante', mensajes: 2847, racha: 97, insignia: 'ri-vip-diamond-line' },
  { id: 2, nombre: 'Daniela Quirós', avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20fit%20Latina%20woman%2C%20sporty%20casual%20look%2C%20energetic%20smile%2C%20bright%20natural%20light%2C%20clean%20background&width=80&height=80&seq=cabina2-topfan-daniela&orientation=squarish', nivel: 'Diamante', mensajes: 2193, racha: 73, insignia: 'ri-vip-diamond-line' },
  { id: 3, nombre: 'Diego Montenegro', avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%20with%20beard%2C%20stylish%20casual%20look%2C%20confident%20friendly%20expression%2C%20modern%20studio%20lighting%2C%20clean%20warm%20background&width=80&height=80&seq=cabina2-topfan-diego2&orientation=squarish', nivel: 'Oro', mensajes: 1654, racha: 52, insignia: 'ri-vip-crown-line' },
  { id: 4, nombre: 'Carlos Ramírez', avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20friendly%20face%2C%20casual%20polo%20shirt%2C%20natural%20daylight%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=cabina2-topfan-carlos2&orientation=squarish', nivel: 'Oro', mensajes: 1420, racha: 41, insignia: 'ri-vip-crown-line' },
  { id: 5, nombre: 'Valentina Castro', avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20artistic%20style%2C%20creative%20look%2C%20warm%20smile%2C%20soft%20ambient%20light%2C%20clean%20background&width=80&height=80&seq=cabina2-topfan-valentina2&orientation=squarish', nivel: 'Plata', mensajes: 1156, racha: 28, insignia: 'ri-shield-star-line' },
  { id: 6, nombre: 'Octavio Mendoza', avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20distinguished%20older%20Latino%20gentleman%2C%20silver%20hair%2C%20kind%20wise%20eyes%2C%20elegant%20casual%2C%20warm%20natural%20light%2C%20clean%20soft%20background&width=80&height=80&seq=cabina2-topfan-octavio2&orientation=squarish', nivel: 'Plata', mensajes: 987, racha: 19, insignia: 'ri-shield-star-line' },
  { id: 7, nombre: 'Camila Soto', avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20modern%20trendy%20style%2C%20bright%20genuine%20smile%2C%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=cabina2-topfan-camila2&orientation=squarish', nivel: 'Bronce', mensajes: 756, racha: 12, insignia: 'ri-medal-line' },
  { id: 8, nombre: 'Pedro Gutiérrez', avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%20with%20kind%20eyes%2C%20simple%20casual%20style%2C%20natural%20lighting%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=cabina2-topfan-pedro2&orientation=squarish', nivel: 'Bronce', mensajes: 543, racha: 7, insignia: 'ri-medal-line' },
];

export const cabinaStats: CabinaStats = {
  oyentesAhora: 5124,
  oyentesPico: 6842,
  mensajesHoy: 342,
  saludosHoy: 87,
  cancionesHoy: 64,
  encuestasActivas: 2,
  concursosActivos: 2,
  vipsEnCabina: 18,
  embajadoresEnCabina: 7,
  topFansActivos: 34,
  mensajesPorMinuto: 4.2,
};

export const reglasCabina = [
  {
    id: 1,
    titulo: 'Nada de botones duplicados fuera de Cabina',
    descripcion: 'Responder, destacar, eliminar, bloquear, banear y mover al aire son acciones exclusivas de la Cabina. No existen en ninguna otra parte de la plataforma. La Cabina es el único centro de comando.',
    icono: 'ri-contrast-drop-2-line',
    color: 'from-rose-500 to-amber-500',
  },
  {
    id: 2,
    titulo: 'La Cabina unifica toda la interacción en vivo',
    descripcion: 'Chat, saludos, canciones, encuestas, concursos y top fans conviven en un solo lugar. El locutor no necesita abrir 6 pantallas distintas. Todo está a un clic.',
    icono: 'ri-stack-line',
    color: 'from-emerald-400 to-teal-500',
  },
  {
    id: 3,
    titulo: 'Moderación rápida con atajos de teclado',
    descripcion: 'Cada acción de moderación tiene una tecla asignada. R para responder, D para destacar, E para eliminar, B para bloquear, X para banear, M para mover al aire. Sin menús, sin demoras.',
    icono: 'ri-keyboard-line',
    color: 'from-violet-400 to-indigo-500',
  },
  {
    id: 4,
    titulo: 'Oyentes VIP y Embajadores visibles siempre',
    descripcion: 'Los oyentes VIP y Embajadores tienen insignias destacadas en el chat. Sus mensajes tienen prioridad visual. La comunidad reconoce instantáneamente a sus miembros más valiosos.',
    icono: 'ri-vip-crown-2-line',
    color: 'from-amber-400 to-orange-500',
  },
  {
    id: 5,
    titulo: 'Todo en tiempo real, sin refrescar',
    descripcion: 'Los mensajes llegan instantáneamente. Las encuestas se actualizan con cada voto. Los concursos muestran respuestas en vivo. Los top fans reflejan actividad al segundo. La Cabina está viva.',
    icono: 'ri-timer-flash-line',
    color: 'from-sky-400 to-cyan-500',
  },
];

export const cabinaCoverImage = 'https://readdy.ai/api/search-image?query=Modern%20radio%20broadcast%20studio%20interior%20with%20professional%20microphone%2C%20sound%20mixing%20console%20with%20colorful%20LED%20lights%2C%20acoustic%20foam%20panels%20on%20walls%2C%20warm%20ambient%20lighting%20from%20overhead%20fixtures%2C%20ON%20AIR%20red%20sign%20illuminated%2C%20professional%20podcast%20recording%20setup%2C%20sleek%20contemporary%20design%2C%20editorial%20photography%20with%20dramatic%20shadows%20and%20warm%20tones%2C%20cinematic%20depth%20of%20field&width=1600&height=900&seq=cabina2-hero-cover&orientation=landscape';